import styled, { css } from 'styled-components';

const StyledButton = styled.button<{
	$primary?: boolean;
}>`
	display: grid;
	place-items: center;
	position: relative;
	width: 100%;
	height: 50px;
	padding: 0;
	border-width: 0;
	border-radius: 10px;
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	color: #fff;
	background-color: rgba(255, 255, 255, 0.05);
	cursor: pointer;
	user-select: none;
	transition:
		color 0.25s ease,
		background-color 0.25s ease;

	${({ $primary }) =>
		$primary &&
		css`
			background-color: #1782ff;
		`}

	&:hover {
		color: #000;
		background-color: #fff;
	}

	&:disabled {
		pointer-events: none;
	}
`;

export { StyledButton };
